var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDwg = function SvgDwg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-.008 24.013c0-.668.547-1.184 1.184-1.184h21.617V1.182c0-.637.546-1.184 1.184-1.184.668 0 1.184.547 1.184 1.184V22.83h21.647c.638 0 1.184.516 1.184 1.184 0 .638-.546 1.184-1.184 1.184H25.161v21.617c0 .638-.516 1.184-1.184 1.184a1.206 1.206 0 0 1-1.184-1.184V25.197H1.176a1.206 1.206 0 0 1-1.184-1.184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.894 37.998c-3.355 0-5.146-1.776-5.146-5.1V14.454c0-3.325 1.79-5.1 5.146-5.1H33.23c3.37 0 5.147 1.775 5.147 5.1v18.444c0 3.324-1.776 5.1-5.147 5.1zm.288-3.385h17.776c1.306 0 2.05-.668 2.05-2.064v-17.73c0-1.398-.744-2.08-2.05-2.08H15.182c-1.336 0-2.05.682-2.05 2.08v17.73c0 1.396.714 2.064 2.05 2.064"
  })));
};
export default SvgDwg;